import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Observable } from "rxjs";

import { Filtros } from "../../../../../models/cotizacion/filtros.model";

@Component({
  selector: "app-buscar-dialog",
  templateUrl: "./buscar-dialog.component.html",
  styleUrls: ["./buscar-dialog.component.css"],
})
export class BuscarDialogComponent {
  tiposDocumento$: Observable<any[]>;
  productos$: Observable<any[]>;
  filtros = {} as Filtros;

  constructor(
    public dialogRef: MatDialogRef<BuscarDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.tiposDocumento$ = data.tiposDocumento;
    this.productos$ = data.productos;
  }

  limpiar() {
    this.filtros = {} as Filtros;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/mis-negocios/shared/components/buscar-dialog/buscar-dialog.component.ts